import type { FC } from "react";
import { Button, Center, Loader, Stack, Text, Title } from "@mantine/core";

export const OrderPageLoading: FC = () => (
  <Center py="s12">
    <Loader />
  </Center>
);

export const OrderPageError: FC = () => (
  <Center py="s12">
    <Stack align="center" gap="s3">
      <Title order={3}>Impossible de charger la commande</Title>
      <Text size="sm">
        {
          "La commande n'a pas pu être affichée. Réessayez dans quelques instants."
        }
      </Text>
      <Button onClick={() => window.location.reload()}>
        Recharger la page
      </Button>
    </Stack>
  </Center>
);
